import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';

import {
    getApiConnectionUsers,
    getApiConnections,
    getFirms,
    getUsers
} from './common';

const getApiConnectionId = (_state: AdminState | ClientState, _userId: string, apiConnectionId: string) => apiConnectionId;

const getApiConnectionUsersArray = createSelector([getApiConnectionUsers], (apiConnectionUsers) => {
    return Object.keys(apiConnectionUsers)
        .map(id => apiConnectionUsers[id])
        .filter(apiUser => !apiUser.IsDeleted);
});

export const getApiConnectionUsersWithConnectionArray = createSelector(
    [ getApiConnectionUsersArray, getApiConnections ],
    (apiConnectionUsers, apiConnections) => {
        return apiConnectionUsers.map((apiConUser) => ({
            apiConnectionUser: apiConUser,
            apiConnection: apiConnections[apiConUser.APIConnectionId]
        }));
    }
);

export const getApiConnectionUsersandFirm = createSelector(
    [ getApiConnectionUsersArray, getApiConnectionId, getUsers, getFirms, getApiConnections ],
    (apiConnectionUsesrArray, apiConnectionId, users, firms, apiConnections) => {
        if (!apiConnectionId) return [];

        const apiConnectionUsersIDs = apiConnectionUsesrArray.filter(user => user.APIConnectionId == apiConnectionId);

        const APIConnectionUsers = apiConnectionUsersIDs
            .map(apiConnection => {
                const userObj = users[apiConnection.UserId];
                const firm = firms[userObj.FirmId];

                return {
                    apiConnection: { ...apiConnections[apiConnectionId] },
                    apiUser: apiConnection,
                    user: { ...userObj },
                    Firm: { ...firm }
                };
            })
            .filter((mappedApiConnection) => {
                // Deleted users will be filtered out by getApiConnectionUsersArray
                // Same with Deleted API, only need to check firm
                if (mappedApiConnection.Firm?.IsClosed) {
                    return false;
                }

                return true;
            });

        return APIConnectionUsers;
    }
);